import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container-fluid fill" }
const _hoisted_2 = { class: "row dialog-header justify-content-between" }
const _hoisted_3 = { class: "col-10 my-1 ml-2" }
const _hoisted_4 = { class: "dialog-title" }
const _hoisted_5 = {
  key: 0,
  class: "col-1 mr-2"
}
const _hoisted_6 = { class: "row mt-1 no-gutters dialog-content-row" }
const _hoisted_7 = { class: "col no-gutters dialog-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", {
        class: "dialog-overlay",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickOverlay && _ctx.onClickOverlay(...args)))
      }, [
        _createElementVNode("div", {
          class: "dialog",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onMouseDownInDialog && _ctx.onMouseDownInDialog(...args))),
          style: _normalizeStyle({width: _ctx.widthStyle(), height: _ctx.heightStyle()})
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.title), 1)
              ]),
              (!_ctx.hideCloseButton)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", {
                      class: "close-button",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.requestCloseDialog && _ctx.requestCloseDialog(...args)))
                    }, [...(_cache[3] || (_cache[3] = [
                      _createElementVNode("div", { class: "close-x-button" }, null, -1)
                    ]))])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _renderSlot(_ctx.$slots, "dialogContent", {}, undefined, true)
              ])
            ])
          ])
        ], 4)
      ], 512), [
        [_vShow, _ctx.showDialog]
      ])
    ]),
    _: 3
  }))
}